import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  description: string;
  cancelText: string;
  confirmText: string;
  operation: string;
  submitText: string;
  promptText: string;
  id: string;
  type: string;
  closeOnlyCurrentModal: boolean;
}

@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
})
export class GenericDialogComponent {
  value: boolean;
  constructor(
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly dialog: MatDialog
  ) {}
  closeModal(value?: boolean, closeOnlyCurrentModal: boolean = false) {
    if (closeOnlyCurrentModal) {
      return this.dialogRef.close();
    }
    if (this.data.type == 'changesSuccessfully') {
      return this.dialog.closeAll();
    }

    this.dialogRef.close(value);
  }
  closeAllModals(closeOnlyCurrentModal: boolean = false) {
    if (closeOnlyCurrentModal) {
      return this.dialogRef.close();
    }
    this.dialog.closeAll();
  }
}
